<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles clueManagement">
            <van-loading
                class="pageLogin"
                v-if="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="线索管理"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            ></van-nav-bar>
            <section>
                <van-search v-model="queryCriteria" placeholder="线索编号/客户名称/工程名称/联系人/联系人手机号" @change="search"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list" v-if="listData.length > 0">
                            <template v-for="(item, index) in listData">
                                <li :key="index">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span class="headerName">{{ item.client_name }}</span>
                                            <span class="contractStatus">{{ item.clue_tracking_results }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>工程名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_22.png" alt="">
                                                <span>线索编号：{{ item.clue_number }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>客户联系人：{{ item.client_contact_name }}</span>
                                            </p>
                                        </div>
                                        <button class="telephone" @click="openContactInfo(item)"></button>
                                    </div>
                                    <div class="form">
                                        <button @click="openClueRecord(item, 'followUp')">
                                            <img src="@/assets/images/icons/icon_2.png" alt="">
                                            跟进
                                        </button>
                                        <button @click="openProjectLocation(item, 'projectLocation')">
                                            <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                            位置
                                        </button>
                                        <button @click="openClueDetails(item, 'details')">
                                            <img src="@/assets/images/icons/icon_23.png" alt="">
                                            更多
                                        </button>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <van-action-sheet
                    v-model="actionSheetShow"
                    cancel-text="取消"
                    class="contactInfo"
                >
                    <h5>{{ contactInfo.client_contact_name }}</h5>
                    <a @click="phone(contactInfo.client_contact_phone)">联系电话：{{ contactInfo.client_contact_phone }}</a>
                </van-action-sheet>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 线索管理
    name: 'clue-management',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'clue-management');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 联系人上拉菜单状态
            actionSheetShow: false,
            // 上拉索引
            count: 0,
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 页面login状态
            loading: false,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 当前任务联系方式
            contactInfo: '',
            // 线索详情数据
            clueDetails: {},
            // 请求列表数据地址
            getUrl: '',
            // 是否是查询
            isQuery: false,
            // 查询条件
            queryCriteria: '',
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 搜索
        search() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            this.gitListData();
        },
        // 打开联系人信息上拉菜单
        openContactInfo(data) {
            this.contactInfo = data;
            this.actionSheetShow = true;
        },
        // 下拉刷新
        onRefresh() {
            this.listData = [];
            this.count = 1;
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 拉取列表数据
        gitListData() {
            // 请求列表数据地址
            if (this.queryCriteria && this.queryCriteria !== '') {
                // eslint-disable-next-line max-len
                this.getUrl = '/interfaceApi/sale/clue_manager/get_clues_page?Keywords=' + this.queryCriteria + '&pageindex=' + this.count + '&pageSize=3';
            } else {
                this.getUrl = '/interfaceApi/sale/clue_manager/get_clues_page?pageindex=' + this.count + '&pageSize=3';
            }

            this.$axios
                .get(this.getUrl)
                .then(res => {
                    this.total = res.total;
                    if (this.listData.length < 1 || this.isQuery) {
                        this.listData = res.rows;
                        this.isQuery = false;
                        this.finished = false;
                    } else {
                        res.rows.forEach(item => {
                            this.listData.push(item);
                        });
                    }
                    if (this.listData.length >= this.total) {
                        this.finished = true;
                    }
                    this.isUpLoading = false;
                    this.isLoading = false;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
        // 点跟进打开线索记录页
        openClueRecord(data, type) {
            this.gitClueDetailsData(data, type);
        },
        // 点定位打开工程位置页
        openProjectLocation(data, type) {
            this.gitClueDetailsData(data, type);
        },
        // 点更多打开线索详情页
        openClueDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/clueDetails', query: { ciid: data.ciid } });
        },
        // 拉取线索详情数据
        gitClueDetailsData(data, type) {
            this.$axios
                .get('/interfaceApi/sale/clue_manager/get_clue/' + data.ciid)
                .then(res => {
                    this.clueDetails = res;
                    this.loading = false;
                    this.$router.isBack = 2;
                    if (type === 'followUp') {
                        this.$router.push({
                            path: '/clueRecord',
                            query: {
                                data: this.clueDetails,
                                type: '/clueManagement',
                            },
                        });
                    } else if (type === 'projectLocation') {
                        this.$router.push({
                            name: 'ProjectLocation',
                            params: {
                                data: this.clueDetails,
                                type: '/clueManagement',
                            },
                        });
                    }
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
        // 调用打电话功能
        phone(phoneNumber) {
            this.$callMobile('JYTeamsNative', 'jyMakePhoneCall', phoneNumber);
            this.actionSheetShow = false;
        },
    },
};
</script>
<style lang="stylus" scoped>
.clueManagement
    height 100%
    section
        height calc(100% - 44rpx)
        .operate
            height 45rpx
            position relative
            button
                width 50%
                height 45rpx
                font-size 14rpx
                line-height 45rpx
                color #333333
                border none
                background #fff
            &:after
                content ''
                border-left 2px solid #F0F0F0
                height 15rpx
                position absolute
                left 50%
                top 15rpx
        .van-pull-refresh
            height calc(100% - 45rpx)
            overflow-y auto
            .list
                li
                    .telephone
                        width 25rpx
                        height 25rpx
                        background url('./../../../assets/images/clueManagement/phone@2x.png')
                        background-size 100% 100%
                        border none
                        position absolute
                        right 15rpx
                        bottom 55rpx
        .contactInfo
            h5,a
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            a
                display block
                color #0189FC
                border-bottom 1px solid #F0F0F0

</style>